import { useState, FormEvent } from 'react';
import { Link } from 'react-router-dom';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Alert from '@mui/material/Alert';
import CircularProgress from '@mui/material/CircularProgress';
import LockIcon from '@mui/icons-material/Lock';
import { forgotPassword } from '../api/auth';

export default function ForgotPasswordPage() {
    const [email, setEmail] = useState('');
    const [submitted, setSubmitted] = useState(false);
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e: FormEvent) => {
        e.preventDefault();
        setLoading(true);
        setError('');

        const res = await forgotPassword(email);
        setLoading(false);

        if (res.success) {
            setSubmitted(true);
        } else {
            setError(res.message ?? 'Something went wrong. Please try again.');
        }
    };

    return (
        <Box minHeight="100vh" display="flex" alignItems="center" justifyContent="center" bgcolor="background.default">
            <Card sx={{ width: 380, border: 'none' }}>
                <CardContent sx={{ p: 4 }}>
                    <Box textAlign="center" mb={3}>
                        <LockIcon sx={{ fontSize: 48, color: 'accent.main' }} />
                        <Typography variant="h6" fontWeight={700} mt={1}>Reset Password</Typography>
                        <Typography variant="body2" sx={{ color: 'text.secondary' }}>Enter your email to receive a reset link</Typography>
                    </Box>

                    {submitted ? (
                        <Alert severity="success">
                            If an account exists with that email, you'll receive a password reset link.
                        </Alert>
                    ) : (
                        <>
                            {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
                            <Box component="form" onSubmit={handleSubmit} display="flex" flexDirection="column" gap={2}>
                                <TextField
                                    id="email"
                                    label="Email"
                                    type="email"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    required
                                    autoComplete="email"
                                    size="small"
                                    fullWidth
                                />
                                <Button type="submit" variant="contained" fullWidth disabled={loading}>
                                    {loading ? <CircularProgress size={20} color="inherit" sx={{ mr: 1 }} /> : null}
                                    Send Reset Link
                                </Button>
                            </Box>
                        </>
                    )}

                    <Box mt={2}>
                        <Button component={Link} to="/login" size="small" sx={{ textTransform: 'none', color: 'accent.main' }}>
                            ← Back to login
                        </Button>
                    </Box>
                </CardContent>
            </Card>
        </Box>
    );
}
